import React from 'react';
import { useNavigate } from 'react-router-dom';

// Navigation to a page that robots.txt keeps away from crawlers (/search, /jobs/create, /auth/login,
// /register). A plain <a href> lets Googlebot discover the URL and list it as "Blocked by robots.txt"
// in Search Console; a button navigates the same way for people without exposing the URL.
const openInNewTab = (to: string) => window.open(to, '_blank', 'noopener');

type PrivateLinkProps = Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'type'> & { to: string };

export const PrivateLink: React.FC<PrivateLinkProps> = ({ to, onClick, className, children, ...rest }) => {
    const navigate = useNavigate();
    return (
        <button
            type="button"
            {...rest}
            // Tailwind preflight gives buttons cursor: default; keep the link hand cursor.
            className={className ? `cursor-pointer ${className}` : 'cursor-pointer'}
            onClick={(event) => {
                onClick?.(event);
                if (event.defaultPrevented) return;
                if (event.ctrlKey || event.metaKey || event.shiftKey) openInNewTab(to);
                else navigate(to);
            }}
            // Middle click: a button has no native "open in a new tab".
            onAuxClick={(event) => {
                if (event.button === 1) openInNewTab(to);
            }}
        >
            {children}
        </button>
    );
};

export default PrivateLink;
